import GamesPage from './GamesPage.vue';

// @ts-ignore
GamesPage.install = (Vue) => {
  Vue.component((GamesPage as any).options.name, GamesPage);
};

export default GamesPage;
